/* eslint func-names: 0 */
import { AppIntegrationsRepository, MeRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import { DevicesProcessor } from 'common/repositoryProcessors/index';

angular.module('controllers').controller(
    'ProductCard',
    (
        $scope, $state,
        $stateParams, $window, $location,
        Util,
    ) => {

        const queryParams = $location.search();

        $scope.browserName = $window.browserName.toLowerCase();
        $scope.User = MeRepository.getMyUser();
        $scope.screenshotSelected = false;
        $scope.tab = 'screenshots';
        $scope.appId = queryParams.appId || $stateParams.resourceId;

        $scope.app = AppIntegrationsRepository.getById($scope.appId);
        $scope.deviceData = DevicesProcessor.getAll();

        $scope.close = (newState) => {

            let currentState;
            if (!newState) {

                currentState = $state.current.name;
                newState = currentState.substr(0, currentState.indexOf('.ltb'));

            }
            $state.go(newState);

        };

        if ($stateParams.modal) {

            $stateParams.modal.result.then(() => {
            }, () => {

                $scope.close();

            });

        }

        $scope.init = () => {

            // redirect to dashboard if the service is not active
            if (!$scope.app) {

                $scope.close();
                return;

            }

            Mixpanel.send('ConnectWeb Store Product Card Open', {
                Product: Util.deepFind($scope.app, 'attributes.resource.oeName'),
            });

            $scope.features = $scope.app.attributes.resource.oeFeatures;

        };

        $scope.backScreen = () => {

            $scope.screenshotSelected = false;

        };

        $scope.loadPictures = () => {

            angular.element('.screenshots-cnt img').on('click', function () {

                $scope.screenshotSelected = true;
                if (!angular.element(this).hasClass('big-pic')) {

                    angular.element('.big-pic').remove();
                    angular.element('.screenshots-cnt img').removeClass('selected');
                    angular.element(this).addClass('selected');
                    angular.element('.screenshots-cnt')
                        .append(`<img class="big-pic" src="${this.src}" />`);

                }

            });
            angular.element('.screenshots-cnt img').on('mouseover', function () {

                if ($scope.screenshotSelected === true) {

                    if (!angular.element(this).hasClass('big-pic')) {

                        angular.element('.big-pic').remove();
                        angular.element('.screenshots-cnt img').removeClass('selected');
                        angular.element(this).addClass('selected');
                        angular.element('.screenshots-cnt')
                            .append(`<img class="big-pic" src="${this.src}" />`);

                    }

                }

            });

        };

        /**
        * Open cart iframe
        *
        * @param {String} appId Service id
        */
        $scope.buy = (appId) => {

            Mixpanel.send('ConnectWeb Store Buy Click', {
                'Product ID': appId,
            });

            $state.go('root.dashboard.store.ltb.buy', {
                ltb: 'payment-cart',
                resourceId: appId,
                subsource: 'store',
                promotion: true,
            }, {
                reload: false,
            });

        };

        $scope.onTabClick = (tabName) => {

            $scope.tab = tabName;

            Mixpanel.send(`ConnectWeb ${tabName} Click`, {
                Page: 'Store Product Card',
                Product: Util.deepFind($scope.app, 'attributes.resource.oeName'),
            });

        };

        $scope.init();

    },
);



// WEBPACK FOOTER //
// ./scripts/controllers/modals/store-product-card/product-card.js